/* @flow */


import _multiidpbase from './multiidpbase';
import {
  loadJSWithTimeout,
  isJSONSupported,
  JSONParse
} from '../utils/browserutil';
import { logDebug } from '../utils/logger';
import isdebugEnabled from '../utils/debug';
import getCVars from '../utils/gputils';
import { IDP_PUBLINK, USER_ID_PUBLINK } from './idpconstants';
import { getCookie } from '../utils/cookie';
import { isObject } from '../utils/coreutils';

const SCRIPT_LOAD_TIMEOUT_MSG = 500;
const PUBLINK_COOKIE_NAME = '_publink';

const PUBLINK_IDP_KEYS = {
  [USER_ID_PUBLINK]: 'publink'
};

/**
 * siteID is stored as _pid to reuse
 * and we need extra lid for this IDP partner
 * This one doesn't generate any new ID and
 * augments PubCommonID. So, nothing to return here
 */

class _publinkid extends _multiidpbase {
  _lid: string;

  _apiKey: string;

  constructor(name: string = '') {
    super(name);
    this._lid = '';
    this._apiKey = '';
  }

  _updateConfig(o: _publinkIDPConfig) {
    super._updateConfig(o);

    const { lid = '', apiKey = '' } = o;
    this._lid = lid;
    this._apiKey = apiKey;

    // inject global var
    // eslint-disable-next-line camelcase
    this._win.cnvr_launcher_options = this._win.cnvr_launcher_options || {};

    this._win.cnvr_launcher_options.lid = this._lid;
  }

  _isSupported(): boolean {
    return super._isSupported() && isJSONSupported();
  }

  _fetchfromServer() {
    // check if we have valid email hashes
    // get customer's hash values
    const cvars = getCVars();
    const {
      _uh: sha1Email = '',
      _uh4: md5Email = '',
      _uh6: sha256Email = ''
    } = cvars;
    const emailHashes = [md5Email, sha1Email, sha256Email].filter(
      v => v.length !== 0
    );
    // if email hashes are not available, nothing to do here
    if (emailHashes.length === 0) {
      return;
    }

    // try to load the script. If it's successful, start the library
    loadJSWithTimeout(this._url, this._doc, true, SCRIPT_LOAD_TIMEOUT_MSG, {
      object: 'conversant'
    })
      .then(() => {
        logDebug('PubLink is loaded!');
        try {
          let opt = {
            apiKey: this._apiKey,
            siteId: this._pid,
            emailHashes
          };
          if (isdebugEnabled()) {
            opt = {
              ...opt,
              logging: 'debug'
            };
          }
          this._win.conversant.launch('publink', 'start', opt);
        } catch (error) {
          logDebug(`${this._name} Failed to invoke launcher ${error}`);
        }
        return true;
      })
      .catch((/* error */) => {
        // catch and ignore error
        /* logDebug(`Failed to load PubLink ${error}`); */
      });
  }

  _loadFromCache(): boolean {
    if (Object.keys(this._cachedObj).length !== 0) {
      return true;
    }
    // try to read from cookie and cache the object
    const oCookie =
      JSONParse(getCookie(PUBLINK_COOKIE_NAME) || '{}', 'publinkid') || {};
    if (isObject(oCookie) && Object.keys(oCookie).length > 0) {
      // convert for quick/easy lookup
      Object.entries(PUBLINK_IDP_KEYS).forEach(([id, remoteKey]) => {
        if (typeof remoteKey === 'string') {
          const val = oCookie[remoteKey] || '';
          this._cachedObj[id] = val;
        }
      });
    }
    const bLoaded = Object.keys(this._cachedObj).length > 0;
    if (bLoaded && this._idUpdateTime === 0) {
      this._idUpdateTime = Date.now();
    }
    return bLoaded;
  }

  _refreshID() {
    this._fetchfromServer();
  }

  getID(idpKey: string = ''): string {
    // script loading takes time. Check cookie once
    this._loadFromCache();

    return this._cachedObj[idpKey];
  }
}

const pl: _publinkid = new _publinkid(IDP_PUBLINK);
export default pl;
